import React from 'react';

type CheckBoxProps = {
  className?: string;
  name: string;
  disabled?: boolean;
  error?: boolean;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  [x: string]: any;
};

function CheckBox({ className, name, error, checked, onChange, ...props }: CheckBoxProps) {
  return (
    <input
      {...props}
      style={{ boxShadow: 'none' }}
      className={`${className} ${error ? 'text-river-red !border-river-red' : ''}`}
      type="checkbox"
      name={name}
      aria-label={name}
      onChange={onChange}
      checked={checked}
    />
  );
}

export default CheckBox;
